import React from "react";
//#region types
import { StateFlowStep } from "models/propTypes/stateFlowPropTypes";
import { IncomingInvoiceStateFlowProps } from "models/propTypes/incomingInvoicePropTypes";
//#endregion
//#region components
import { StateFlow, useMountedState } from "components/common";
import { useIncomingInvoiceService } from "serviceHooks";
//#endregion
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";

const IncomingInvoiceStateFlow: React.FC<IncomingInvoiceStateFlowProps> = (props) => {
  const incomingInvoiceService = useIncomingInvoiceService();
  const { getMounted } = useMountedState();
  const { invoiceId, currentState } = props;

  const [states, setStates] = React.useState<StateFlowStep[]>();

  const getCurrentState = () => {
    switch (currentState) {
      case ApiModels.IncomingInvoiceState.PaymentProcessing:
      case ApiModels.IncomingInvoiceState.PaymentSign:
      case ApiModels.IncomingInvoiceState.PayoutRescheduled:
      case ApiModels.IncomingInvoiceState.Stopped:
        return ApiModels.IncomingInvoiceState.Booked;
      case ApiModels.IncomingInvoiceState.Denied:
      case ApiModels.IncomingInvoiceState.SentBack:
      case ApiModels.IncomingInvoiceState.DeniedAndHandled:
      case ApiModels.IncomingInvoiceState.DeniedAndUnhandled:
        return undefined;
      default:
        return currentState;
    }
  };

  React.useEffect(() => {
    incomingInvoiceService.getStateLogs(invoiceId).then((items) => {
      if (getMounted()) {
        const receivedStates = items;

        if (
          currentState === ApiModels.IncomingInvoiceState.Signee &&
          receivedStates.find((x) => x.status === ApiModels.IncomingInvoiceState.Signee) === undefined
        ) {
          const start = receivedStates.findIndex((x) => x.status === ApiModels.IncomingInvoiceState.Received);
          receivedStates.splice(start + 1, 0, {
            status: ApiModels.IncomingInvoiceState.Signee,
            changedByName: "",
            isIntermediateState: false,
            active: false,
          });
        }

        const hasSignee = receivedStates?.find((x) => x.status === ApiModels.IncomingInvoiceState.Signee) !== undefined;

        const mappedStates: StateFlowStep[] = [];
        receivedStates.forEach((item) => {
          let existing = mappedStates.find((x) => x.state === item.status);
          const currItem = {
            state: item.status,
            stateText: incomingInvoiceService.getStateFlowText(item.status, hasSignee),
            updatedById: item.changedById,
            updatedByName: item.changedByName,
            date: item.date,
          };

          if (existing === undefined) mappedStates.push(currItem);
          else existing = currItem;
        });
        getMounted() && setStates(mappedStates);
      }
    });
  }, [invoiceId, currentState]);

  return <>{states && <StateFlow steps={states} currentState={getCurrentState()} />}</>;
};

export default IncomingInvoiceStateFlow;
